<template>
  <BbSwitch v-model="selectedPage" :items="selectedPages" class="switch-page" />
</template>

<script>
import { watch, ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router/dist/vue-router';
import { Routes } from '~/constants/routes';
import useConversations from '~/composables/useConversations';
import useAuthoring from '~/composables/useAuthoring';
import useFormFilters from '~/composables/useFormFilters';

export default {
  setup() {
    const router = useRouter();
    const { t } = useI18n();

    const { isAuthoringPage } = useAuthoring();
    const { setDefaultState } = useConversations();

    const selectedPage = ref(isAuthoringPage.value ? 1 : 0);

    const selectedPages = [{ title: t('assist.assist') }, { title: t('author.author') }];

    onMounted(() => {
      if (isAuthoringPage.value) {
        selectedPage.value = 1;
      } else {
        selectedPage.value = 0;
      }
    });

    watch(
      () => selectedPage.value,
      () => {
        setDefaultState();
        if (selectedPage.value === 1) {
          router.push({ name: Routes.Authoring.name });
        } else if (selectedPage.value === 0) {
          router.push({ name: Routes.Conversation.name });
        }
      },
    );

    return {
      selectedPages,
      selectedPage,
    };
  },
};
</script>

<style lang="scss" scoped>
.switch-page {
  width: 200px;
  height: 48px;
  margin: auto;
  overflow: auto;
  display: flex;
  justify-content: center;

  :deep(.v-btn__content) {
    font-size: 14px;
    font-weight: 500;
  }

  :deep(.switch-item) {
    border: unset !important;
    background-color: $bb-neutral-0 !important;
    height: 100%;
    border-radius: 0px !important;
    width: 200px;
  }

  :deep(.switch-item .v-slide-group__container .v-slide-group__content) {
    gap: 12px;
  }

  :deep(.switch-item .v-slide-group__container .v-slide-group__content .v-tab--selected) {
    background-color: $bb-neutral-1 !important;
  }

  :deep(.switch-item .v-slide-group__container .v-slide-group__content .v-tab) {
    background-color: $bb-neutral-4;
    border-radius: 15px !important;
    height: 46px;

    &:active {
      background-color: $bb-neutral-1 !important;
    }

    &:hover {
      background-color: $bb-neutral-3 !important;
    }
  }
}
</style>
